import { render, staticRenderFns } from "./files.vue?vue&type=template&id=53821f08&"
import script from "./files.vue?vue&type=script&lang=js&"
export * from "./files.vue?vue&type=script&lang=js&"
import style0 from "./files.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports